import React, { Suspense, useRef } from "react";
import ScrollEntry from "./ScrollEntry";

const RenderOnScrollEntry = ({
  children,
  observerOptions,
  fallback = <div>Loading...</div>,
}) => {
  const entryRef = useRef(null);
  const entered = ScrollEntry({ ref: entryRef, observerOptions });

  return (
    <div ref={entryRef}>
      {entered ? <Suspense fallback={fallback}>{children}</Suspense> : null}
    </div>
  );
};

export default RenderOnScrollEntry;
